import forEach from '../../../../javascripts/dom/forEach';
import trackEvent from '../../../../javascripts/helpers/trackEvent';
import BaseModule from '../../../../javascripts/helpers/baseModule';
import triggerCustom from '../../../../javascripts/events/triggerCustom';

const subscriptionForms = document.querySelectorAll('[data-js-module="o-subscription-form"]');

export default class SubscriptionForm extends BaseModule {
  static bindTrackingEvents(trackingModule) {
    const trackingTargets = trackingModule.querySelectorAll('input, button');
    const form = trackingModule.querySelector('form');

    forEach(trackingTargets, (index, element) => {
      const elementAction =
        element.type === 'radio' ? element.getAttribute('value') : element.getAttribute('name');
      if (element.type === 'text' || element.type === 'email') {
        element.addEventListener('focus', () => {
          trackEvent('Lead_Subscription_Form', elementAction, 'GA');
        });
      } else {
        element.addEventListener('click', () => {
          if (!form.checkValidity() && element.tagName === 'BUTTON') {
            return;
          }
          trackEvent('Lead_Subscription_Form', elementAction, 'GA');
        });
      }
    });
  }

  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    this.submitFlag = false;
    this.currentForm = null;

    this.getElements([
      { id: 'form', selector: 'form' },
      { id: 'submit', selector: 'submit' },
      { id: 'recaptcha', selector: 'recaptcha' }
    ]);

    SubscriptionForm.bindTrackingEvents(element);
    if(document.querySelector('[data-recaptcha-form-field]')) {
      this.initializeEvents();
      this.registerCallback();
    }
    else {
      this.bindClickEvents();
    }
  }

  initializeEvents() {
    // used with visible recaptcha
    [...document.querySelectorAll('[data-recaptcha-form-submit]')].map(button => {
      button.addEventListener('click', event => this.visibleRecaptchaButtonClicked(event));
    });

    // used with invisible recaptcha
    [...document.querySelectorAll('[data-callback="onRecaptchaSubmit"]')].map(button => {
      button.addEventListener('click', event => this.invisibleRecaptchaButtonClicked(event));
    });
  }

  visibleRecaptchaButtonClicked(event) {
    event.preventDefault();
    event.target.closest('form').submit();
  }

  invisibleRecaptchaButtonClicked(event) {
    event.preventDefault();

    if (this.currentForm === null) {
      this.currentForm = event.target.closest('form');
    }
  }

  registerCallback() {
    window.onRecaptchaSubmit = this.submitCurrentForm.bind(this);
    window.onRecaptchaCallback = this.recaptchaConfirmed.bind(this);
    window.onRecaptchaExpired = this.recaptchaExpired.bind(this);
    window.onRecaptchaError = this.recaptchaError.bind(this);
  }


  submitCurrentForm(recaptchaResponse) {
    this.currentForm.querySelector('[data-recaptcha-form-field]').value = recaptchaResponse;
    //this.elements.form.submit();
    //this.currentForm = null;
    if (this.submitFlag) {
      this.submitFlag = false; // reset flag
      return; // let the event bubble away
    }

    this.validateFormElements();
  }

  recaptchaConfirmed(recaptchaResponse) {
    document.querySelector('[data-recaptcha-form-field]').value = recaptchaResponse;
  }

  recaptchaExpired() {
    document.querySelector('[data-recaptcha-form-field]').value = '';
  }

  recaptchaError() {
    document.querySelector('[data-recaptcha-form-field]').value = '';
  }

  bindClickEvents() {
    // A form template without a marked submit button must not throw: the
    // bundle runs as one script, so an error here stops every module after it.
    if (!this.elements.submit) {
      return;
    }

    this.elements.submit.addEventListener('click', e => {
      if (this.submitFlag) {
        this.submitFlag = false; // reset flag
        return; // let the event bubble away
      }

      e.preventDefault();
      this.validateFormElements();
    });
  }

  validateFormElements() {
    let validForm = false;

    triggerCustom(this.elements.form, 'validate', {
      detail: {
        cb: isValid => {
          validForm = isValid;
        }
      }
    });

    if (validForm) {
      this.submitFlag = true; // set flag
      if(document.querySelector('[data-recaptcha-form-field]')) {
        this.elements.form.submit();
      }
      else {
        this.elements.submit.click();
      }

    }
  }
}

if (subscriptionForms.length) {
  forEach(subscriptionForms, (index, element) => new SubscriptionForm(element));
}
